import "@fontsource/inter";
import CssBaseline from '@mui/material/CssBaseline';
import ReactDOM from 'react-dom/client';
import { MemoryRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store/store';
import App from './Components/App/App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const CURRENT_VERSION = "1.0.0"; // Update this on each deployment

if (localStorage.getItem("edullaAppVersion") !== CURRENT_VERSION) {
  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem("edullaAppVersion", CURRENT_VERSION);
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const tid = new URLSearchParams(window.location.search)?.get("tid") ?? "";
window.sessionStorage.setItem("edullaTid", tid);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <CssBaseline />
        <App />
      </Router>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
